



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import MandateState from "@/models/Accounts/DepositAccounts/Mandates/MandateState";

@Component({ name: 'MandateState', })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: MandateState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case MandateState.Active:
                color = "success--text";
                break;
            case MandateState.PendingInvitation:
                color = "warning--text";
                break;
            case MandateState.Cancelled:
                color = "error--text";
                break;
            case MandateState.Rejected:
                color = "error--text";
                break;
            case MandateState.Finished:
                color = "success--text";
                break;
            case MandateState.Returned:
                color = "warning--text";
                break;
        }
        return color;
    }

}
